import { bool, object } from 'prop-types';

const CategoryServerPropTypes = {
    category: object,
    isTouch: bool

};

const CategoryClientPropTypes = {
    category: object,
    isTouch: bool
};

export {
    CategoryServerPropTypes,
    CategoryClientPropTypes
};
